import { GameConfig } from "../GameConfig/GameConfig.js";
import { PlayerBurstConfig } from "../GameConfig/PlayerConfig.js";

export default class Burst {
  constructor() {
    this.image = new Image();

    this.spriteWidth = PlayerBurstConfig.SPRITE_WIDTH;
    this.spriteHeight = PlayerBurstConfig.SPRITE_HEIGHT;

    this.frameX = 0;

    this.fps = GameConfig.FPS;
    this.frameTimer = GameConfig.FRAME_TIMER;
    this.frameInterval = GameConfig.FRAME_INTERVAL();
  }

  draw(context, deltaTime) {
    if (this.frameTimer > this.frameInterval) {
      if (this.frameX < this.maxFrame) this.frameX++;
      else this.frameX = 0;
      this.frameTimer = 0;
    } else if (typeof deltaTime == "number") {
      this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
    }

    context.drawImage(
      this.image,
      this.frameX * this.spriteWidth,
      0,
      this.spriteWidth,
      this.spriteHeight,
      this.x,
      this.y,
      this.spriteWidth,
      this.spriteHeight,
    );
  }

  update(x, y) {
    this.x = x;
    this.y = y;
  }
}
